/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState, useEffect } from 'react';
import { fetchSearchHistory } from '../services/firestore';
import logo from '../assets/logo.svg';
import sidebarIcon from '../assets/hamburger.svg';
import new_search from '../assets/new_search.svg';
import UserMenu from './userMenu';
// import handleNavbarClick from './TopicFlow.js';

const styles = {
  buttonContainer: (isCollapsed, isMobile) => ({
    display: 'flex',
    flexDirection: isCollapsed ? 'column' : 'row',
    justifyContent: isCollapsed ? 'center' : 'space-between',
    alignItems: 'center',
    gap: isCollapsed ? '0px' : '0px',
    position: isCollapsed ? 'static' : 'absolute',
    top: isCollapsed ? 'auto' : '10px',
    left: isCollapsed ? 'auto' : '10px',
    right: isCollapsed ? 'auto' : '10px',
    width: isCollapsed && !isMobile ? '80px' : 'calc(100% - 30px)', // Adjust width for collapsed mobile
    padding: isCollapsed && !isMobile ? '0' : '0 10px', // Adjust padding for collapsed mobile
  }),
  toggleButton: (isMobile, isCollapsed) => ({
    background: '#141414',
    borderRadius: '12px',
    border: '1px solid rgba(255,255,255,0.1)',
    width: '40px',
    height: '40px',
    color: '#fff',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    marginBottom: isCollapsed ? '10px' : '0',
    marginTop: isMobile && isCollapsed ? '20px' : '0',
    position: isCollapsed ? 'static' : 'relatives',
  }),
  exploreButton: (isMobile, isCollapsed) => ({
    background: '#141414',
    borderRadius: '12px',
    border: '1px solid rgba(255,255,255,0.1)',
    width: '40px',
    height: '40px',
    color: '#fff',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    marginBottom: isCollapsed ? '10px' : '0',
    marginTop: isMobile && isCollapsed ? '10px' : '0',
  }),
  sidebarContainer: (isCollapsed, isMobile) => ({
    position: 'fixed',
    top: 0,
    left: 0,
    height: isCollapsed && isMobile ? '60px' : '100vh',
    width: isCollapsed ? (isMobile ? '100%' : '80px') : (isMobile ? '100%' : '250px'),
    background: isCollapsed ? 'transparent' : 'rgba(20, 20, 20)',
    color: '#fff',
    // transition: 'all 0.3s ease',
    zIndex: 9999,
    display: 'flex',
    flexDirection: isCollapsed && isMobile ? 'row' : 'column',
    justifyContent: isCollapsed && isMobile ? 'space-between' : 'flex-start',
    alignItems: isCollapsed && isMobile ? 'center' : 'center',
    padding: isCollapsed && isMobile ? '0 20px' : '10px 0',
    overflow: 'visible'
  }),
  mobileNavGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: '20px'
  },
  logo: (isCollapsed) => ({
    width: '40px',
    height: '40px',
    objectFit: 'contain',
    cursor: 'pointer',
    marginBottom: '20px',
    left: isCollapsed ? 'auto' : '10px',
    top: isCollapsed ? 'auto' : '10px',
    
  }),
  navList: (isCollapsed, isMobile) => ({
    listStyle: 'none',
    padding: '0',
    margin: 0,
    width: '100%',
    display: isCollapsed && isMobile ? 'none' : 'block', // Only hide in mobile collapsed state
    overflow: 'hidden',
  }),
  navItem: {
    width: '100%',
    padding: '10px 20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    cursor: 'pointer',
    transition: 'background 0.2s',
  },
  navLink: {
    display: 'flex',
    alignItems: 'center',
    color: '#fff',
    textDecoration: 'none',
    width: '100%',
  },
  icon: {
    fontSize: '18px',
    marginRight: '10px',
  },
  label: (isCollapsed) => ({
    fontSize: '14px',
    fontFamily: "'Poppins', sans-serif",
    display: isCollapsed ? 'none' : 'inline',
  }),
  historyContainer: (isCollapsed) => ({
    flex: 1,
    maxHeight: isCollapsed ? '0' : 'calc(100vh - 200px)',
    overflowY: 'auto',
    overflowX: 'hidden',
    width: '100%',
    padding: isCollapsed ? '0' : '10px',
    transition: 'max-height 0.3s ease',
    display: isCollapsed ? 'none' : 'block',
  }),
  historyItem: {
    display: 'block',
    padding: '10px 20px',
    cursor: 'pointer',
    fontSize: '14px',
    fontFamily: "'Poppins', sans-serif",
    color: '#ddd',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textAlign: 'left',
    width: '100%',
    transition: 'all 0.2s ease-in-out',
    borderRadius: '8px',
    boxSizing: 'border-box',
  },
  historyItemHover: {
    backgroundColor: '#333', // Box background color on hover
    color: '#fff', // Optional: Change text color on hover
    overflow: 'hidden',
  },
  historyHeader: {
    fontFamily: "'Poppins', sans-serif",
    margin: '10px 0',
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#fff',
    textAlign: 'left', // Ensure left alignment
    width: '100%', // Use the full width of the container
    paddingLeft: '20px',
  },
  userMenuContainer: (isMobile) => ({
    padding: "10px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: isMobile ? '0' : 'auto', // Push to bottom in desktop view
  }),
};

const SideBar = ({ sessionId, onCollapseChange, user, onSignOut, userId, handleNavbarClick }) => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [history, setHistory] = useState([]);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  const toggleCollapse = () => {
    setIsCollapsed((prev) => {
      const newCollapsedState = !prev;
      if (onCollapseChange) {
        onCollapseChange(newCollapsedState);
      }
      return newCollapsedState;
    });
  };

  const goToExplore = () => {
    window.location.href = '/explore';
  };

  useEffect(() => {
    const loadHistory = async () => {
      try {
        const fetchedHistory = await fetchSearchHistory(userId);
        setHistory(fetchedHistory); // Save fetched history to state
      } catch (error) {
        console.error('Error loading search history:', error);
      }
    };
    loadHistory();  
  }, [sessionId, userId]);

  const renderUserMenu = () => (
    <div style={styles.userMenuContainer(isMobile)}>
      <UserMenu
        user={user}
        onSignOut={onSignOut}
        onSignIn={(signedInUser) => {
          // Callback for when user signs in
          console.log("User signed in:", signedInUser);
        }}
      />
    </div>
  );
  
  const renderMobileHeader = () => (
    <>
      {/* Toggle Button */}
      <button
        onClick={toggleCollapse}
        style={styles.toggleButton(isMobile, isCollapsed)}
        title={isCollapsed ? 'Expand Sidebar' : 'Collapse Sidebar'}
        onMouseEnter={(e) => (e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)')}
        onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}
        aria-label={isCollapsed ? 'Expand Sidebar' : 'Collapse Sidebar'}
      >
        <img
          src={sidebarIcon}
          alt={isCollapsed ? 'Expand Sidebar' : 'Collapse Sidebar'}
          style={{
            width: '24px',
            height: '24px',
            objectFit: 'contain',
          }}
        />
      </button>

      {/* Logo */}
      <img
        src={logo}
        alt="Logo"
        style={{...styles.logo(isCollapsed), marginBottom: 0}}
        onClick={() => (window.location.href = '/')}
      />

      {/* User Menu */}
      {renderUserMenu()}
    </>
  );

  const renderDesktopContent = () => (
    <>
      <img
        src={logo}
        alt="Logo"
        style={styles.logo(isCollapsed)}
        onClick={() => (window.location.href = '/')}
      />
      <div style={styles.buttonContainer(isCollapsed)}>
        {/* Toggle Button - Now on the left */}
        <button
          onClick={toggleCollapse}
          style={styles.toggleButton(isMobile, isCollapsed)}
          title={isCollapsed ? 'Expand Sidebar' : 'Collapse Sidebar'}
        >
          <img
            src={sidebarIcon}
            alt={isCollapsed ? 'Expand Sidebar' : 'Collapse Sidebar'}
            style={{
              width: '24px',
              height: '24px',
              objectFit: 'contain',
            }}
          />
        </button>

        {/* Explore Button - Now on the right */}
        <button
          onClick={goToExplore}
          style={styles.exploreButton(isMobile, isCollapsed)}
          title="New Search"
        >
          <img
            src={new_search}
            alt="New Search"
            style={{
              width: '24px',
              height: '24px',
              objectFit: 'contain',
            }}
          />
        </button>
      </div>
      {/* <ul style={styles.navList(isCollapsed, isMobile)}>
        <NavItem
          icon={
            <img
              src={new_search}
              alt="Open new canvas"
              title="Open new canvas"
              style={{
                width: '24px',
                height: '24px',
                objectFit: 'contain',
              }}
            />
          }
          label="New Canvas"
          link="/explore"
          isCollapsed={isCollapsed}
        />
      </ul> */}
      <div style={styles.historyContainer(isCollapsed)}>
        {!isCollapsed && <div style={styles.historyHeader}>History</div>}
        {history.map((item) => (
          <div
            key={item.id}
            style={styles.historyItem}
            title={item.header}
            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#333')}
            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
            onClick={() => {
                handleNavbarClick(item.header);
                toggleCollapse();
              }
            } // Pass the header as topicContent
          >
            {item.header}
        </div>
        ))}
      </div>
      {renderUserMenu()}
        </>
      );

  return (
    <div style={styles.sidebarContainer(isCollapsed, isMobile)}>
      {isMobile && isCollapsed ? renderMobileHeader() : renderDesktopContent()}
    </div>
  );
};

// const NavItem = React.memo(({ icon, label, link, isCollapsed }) => {
//   return (
//     <li
//       style={styles.navItem}
//       onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#333')}
//       onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
//     >
//       <a href={link} style={styles.navLink}>
//         <span style={styles.icon}>{icon}</span>
//         <span style={styles.label(isCollapsed)}>{label}</span>
//       </a>
//     </li>
//   );
// });

export default SideBar;